import type { ReactNode } from 'react'

/** One titled part of the Settings panel (a labelled region). */
export function Section({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="ml-settings__section" aria-label={title}>
      <h3 className="ml-label ml-settings__title">{title}</h3>
      {children}
    </section>
  )
}
